import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSiteContext } from "../../contexts/SiteProvider";

import "./Login.scss";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import { useForm } from "react-hook-form";

import * as Yup from "yup";
import { getRemeberMe } from "../../services/sessionService";
import { post } from "../../services/smartApiService";

import ModalLoginPage from "./ModalLoginPage";
import NwmForgetPassword from "./NwmForgetPassword";
import { LOGIN_URLS } from "../../api/LoginUrls";

const schema = Yup.object({
  password: Yup.string().required("Password is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email"),
});

const GOOGLE_CLIENT_ID =
  "288181436704-vegignqvfra0d2sqqq174l55r2ug26ol.apps.googleusercontent.com";

const Login: React.FC = () => {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema), // Attach the Yup schema to react-hook-form
  });

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const [isRegistering, setIsRegistering] = useState<boolean>(false);
  const [stage, setStage] = useState<"LOGIN" | "SIGNUP" | "FORGET">("LOGIN");

  // onAuthStateChanged(auth, (currentUser) => {
  // })

  useEffect(() => {
    setStage("LOGIN");
  }, []);
  const toggleCardFlip = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  // const handleLogin = async (data: any) => {
  //   try {
  //     const userCredential = await signInWithEmailAndPassword(
  //       auth,
  //       data.email,
  //       data.password
  //     );
  //     navigate("/admin/dashboard");
  //     return userCredential.user;
  //   } catch (error) {
  //     console.error("Login Error:", error);
  //     return null;
  //   }
  // };

  const { setUser, user } = useSiteContext();

  const handleRemeberMe = () => {
    // let checkbox_remember_me =
    //   formData.checkbox_remember_me !== undefined
    //     ? formData.checkbox_remember_me
    //     : "0";
    // // console.log("check box rmeber me " , checkbox_remember_me, formData);
    // if (checkbox_remember_me === "1") {
    //   setRemeberMe(formData);
    // } else {
    //   removeRemeberMe();
    // }
  };

  const handleRemeberMeLoad = () => {
    // let remember_data = getRemeberMe();
    let remember_data_original = getRemeberMe();
    const remember_data = { ...remember_data_original };
    delete remember_data.epassword;
    if (remember_data) {
      let checkbox_remember_me =
        remember_data.checkbox_remember_me !== undefined
          ? remember_data.checkbox_remember_me
          : "0";
      if (checkbox_remember_me === "1") {
        //setFormData(remember_data);
      }
    }
  };
  useEffect(() => {
    handleRemeberMeLoad();
  }, []);

  const handleLogin = (_data: any) => {
    let url = LOGIN_URLS.LOGIN;
    const subscription = post(url, _data, {
      requiresAuthorization: false,
    }).subscribe((response) => {
      reset();
      setUser(response.data);
      handleRemeberMe();
      const roles = response.data.user.roles; // Assuming roles is an array
      //   console.log("roles " , roles);
      if (roles && roles.includes("ADMIN")) {
        navigate("/dashboard");
      } else {
        navigate("/");
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  };

  const passWordPin = () => {
    return (
      <div className="  has-text-weight-medium has-text-right member-text is-clickable has-text-link">
        <span className="" onClick={() => setStage("FORGET")}>
          Forget Password?
        </span>
      </div>
    );
  };
  const passWordHome = () => {
    return (
      <div className="  has-text-weight-medium member-text has-text-left is-clickable">
        <span className="" onClick={() => navigate("/")}>
          Back to Home
        </span>
      </div>
    );
  };
  const formElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "email",

      element: {
        label: "Email",
        classList: [" is-medium"],
        isRequired: true,
        inputProps: {},
        // placeHolder: "Email ",
        max: 255,
        inputType: "BORDER_LABEL",
        leftIcon: "fa fa-envelope-square",
      },
    },
    {
      type: "PASSWORD",
      width: 12,
      name: "password",
      element: {
        label: "Password",
        // isRequired: true,
        placeHolder: "Password",
        inputType: "BORDER_LABEL",
        leftIcon: "fa fa-lock",
        passwordValidator: false,
      },
    },
    // {
    //   type: "LABEL",
    //   name: "remember_me",
    //   width: 6,
    //   labelComponent: passWordHome(),
    // },
    // {
    //   type: "LABEL",
    //   name: "remember_me",
    //   width: 12,
    //   labelComponent: passWordPin(),
    // },
    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",

      // class_name: "login-button",
      element: {
        label: "Login",
        onClick: handleSubmit(handleLogin),
        classList: ["smart-login-button"],
      },
    },
  ];

  const FEATURES = [
    {
      icon: '🤖',
      title: 'AI-Powered Signals',
      desc: 'Grok AI analyzes 6 signals every 10 min and recommends CE or PE with strike, target & stop-loss.',
    },
    {
      icon: '🐦',
      title: 'Live Twitter Sentiment',
      desc: 'Real-time X/Twitter sentiment for NIFTY, BANKNIFTY and top Nifty 50 companies via Grok.',
    },
    {
      icon: '📊',
      title: 'OI & PCR Analysis',
      desc: 'Max pain, top call/put OI concentration levels, and PCR updated every 5 minutes via KITE API.',
    },
    {
      icon: '🌍',
      title: 'Global Market Watch',
      desc: 'SGX Nifty, Dow/Nasdaq futures, Gold, Crude Oil, DXY and USD/INR tracked every 15 minutes.',
    },
    {
      icon: '🏢',
      title: 'Index Weight Heatmap',
      desc: 'Track all 50 Nifty companies by weight — see which heavyweights are bullish or bearish.',
    },
    {
      icon: '💬',
      title: 'AI Chat Assistant',
      desc: 'Ask Grok anything about today\'s setup, strike selection or risk management with full context.',
    },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: '#07070f',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* LEFT — Features panel (full on desktop, compact header on mobile) */}
      <div style={{
        flex: isMobile ? 'none' : 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isMobile ? 'flex-start' : 'center',
        padding: isMobile ? '1.2rem 1.2rem 0.8rem' : '3rem 3.5rem',
        borderRight: isMobile ? 'none' : '1px solid #14141f',
        borderBottom: isMobile ? '1px solid #14141f' : 'none',
        background: 'linear-gradient(160deg, #07070f 0%, #0a0f1e 100%)',
      }}>
        {/* Brand — always shown */}
        <div style={{ marginBottom: isMobile ? '0.6rem' : '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 10,
              background: 'linear-gradient(135deg, #0d3320, #1a5c3a)',
              border: '1px solid #26a65b',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '1rem',
            }}>📈</div>
            <span style={{ color: '#ddd', fontWeight: 800, fontSize: isMobile ? '1rem' : '1.2rem', letterSpacing: 1 }}>
              SDS Trade
            </span>
          </div>
          <h2 style={{
            color: '#fff', fontWeight: 800, marginBottom: 4, lineHeight: 1.2,
            fontSize: isMobile ? '1.15rem' : '1.7rem',
          }}>
            AI-Powered Option{isMobile ? ' ' : <br />}
            <span style={{ color: '#26a65b' }}>Trading Intelligence</span>
          </h2>
          {!isMobile && (
            <p style={{ color: '#555', fontSize: '0.82rem', lineHeight: 1.6 }}>
              6-signal AI engine · Grok sentiment · OI analysis · Global markets
            </p>
          )}
          {isMobile && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
              {['Grok AI', 'KITE API', 'NIFTY 50', 'Real-time OI'].map(tag => (
                <span key={tag} style={{
                  background: '#0d1a2a', border: '1px solid #1a3a5c',
                  color: '#4fc3f7', fontSize: '0.58rem', padding: '2px 7px', borderRadius: 20,
                }}>{tag}</span>
              ))}
            </div>
          )}
        </div>

        {/* Feature grid — desktop only */}
        {!isMobile && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {FEATURES.map(f => (
                <div key={f.title} style={{
                  background: '#0d0d1a', border: '1px solid #1a1a2e',
                  borderRadius: 8, padding: '12px 14px',
                }}>
                  <div style={{ fontSize: '1.1rem', marginBottom: 4 }}>{f.icon}</div>
                  <div style={{ color: '#ccc', fontSize: '0.75rem', fontWeight: 700, marginBottom: 3 }}>{f.title}</div>
                  <div style={{ color: '#555', fontSize: '0.67rem', lineHeight: 1.5 }}>{f.desc}</div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {['Grok AI', 'KITE API', 'NIFTY 50', 'BANKNIFTY', 'Real-time OI'].map(tag => (
                <span key={tag} style={{
                  background: '#0d1a2a', border: '1px solid #1a3a5c',
                  color: '#4fc3f7', fontSize: '0.62rem', padding: '2px 10px', borderRadius: 20,
                }}>{tag}</span>
              ))}
            </div>
          </>
        )}
      </div>

      {/* RIGHT — Login form */}
      <div style={{
        width: isMobile ? '100%' : 400,
        flexShrink: 0,
        display: 'flex',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'center',
        padding: isMobile ? '1.5rem 1.2rem' : '2rem',
        background: '#07070f',
      }}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          style={{ width: '100%' }}
        >
          <div style={{
            background: '#0d0d1a',
            border: '1px solid #1a1a2e',
            borderRadius: 12,
            padding: '2rem',
          }}>
            {/* Form header */}
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: 8 }}>
                {stage === 'LOGIN' ? '🔐' : stage === 'SIGNUP' ? '✨' : '🔑'}
              </div>
              <h1 style={{ color: '#ddd', fontSize: '1.1rem', fontWeight: 800, marginBottom: 4 }}>
                {stage === 'LOGIN' ? 'Welcome Back' : stage === 'SIGNUP' ? 'Create Account' : 'Reset Password'}
              </h1>
              <p style={{ color: '#555', fontSize: '0.75rem' }}>
                {stage === 'LOGIN' ? 'Sign in to access AI Trader' : stage === 'SIGNUP' ? 'Join SDS Trade today' : 'Enter your email to reset'}
              </p>
            </div>

            {stage === 'LOGIN' && (
              <>
                <SdsForm elements={formElements} errors={errors} control={control} />
                <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'space-between' }}>
                  <span
                    style={{ color: '#4fc3f7', fontSize: '0.72rem', cursor: 'pointer' }}
                    onClick={() => setStage('FORGET')}
                  >
                    Forgot Password?
                  </span>
                </div>
              </>
            )}

            {stage === 'SIGNUP' && (
              <>
                <ModalLoginPage setIsRegistering={setStage} />
                <p style={{ color: '#555', fontSize: '0.75rem', marginTop: '1rem', textAlign: 'center' }}>
                  Already have an account?{' '}
                  <span style={{ color: '#4fc3f7', cursor: 'pointer' }} onClick={() => setStage('LOGIN')}>Sign In</span>
                </p>
              </>
            )}

            {stage === 'FORGET' && (
              <>
                <NwmForgetPassword setIsRegistering={setStage} />
                <p style={{ color: '#555', fontSize: '0.75rem', marginTop: '1rem', textAlign: 'center' }}>
                  Remember it?{' '}
                  <span style={{ color: '#4fc3f7', cursor: 'pointer' }} onClick={() => setStage('LOGIN')}>Back to Login</span>
                </p>
              </>
            )}
          </div>

          <p style={{ color: '#333', fontSize: '0.65rem', textAlign: 'center', marginTop: '1rem' }}>
            © {new Date().getFullYear()} SDS Trade. All rights reserved.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
